


















    import { computed, defineComponent, ref } from "@vue/composition-api";
    import AttachedDeviceModel from "@/models/AttachedDeviceModel";
    import useDeviceData, { Detectors } from "@/store/modules/useDeviceData";
    import { app } from "@/store/index";
    export default defineComponent({
        components:
        {
            GatewaySensor: () =>
                import("./Sensors/GatewaySensorItem.vue"),
            ContactList: () =>
                import("./ContactList.vue"),
            Logbook: () =>
                import("./Logbook.vue"),
            NMEA: () =>
                import("./NMEA.vue")
        },
        setup() {
            const { getDetectorData } = useDeviceData();
            const gatewayModel = computed<AttachedDeviceModel>(() => {
                return getDetectorData(Detectors.gateway);
            });

            const panel = computed<number>(() => {
                if (app.getMyBoatPanelOpen) {
                    console.log("app.getPanelOpenIndex", app.getMyBoatPanelIndex);
                    return app.getMyBoatPanelIndex;
                } else 
{                   console.log("app.getPanelOpenIndex", -1);
                    return -1;
                }
            });

            return {
                gatewayModel,
                panel
            };
        },
    });
